class CountrySelectorDrawer extends MainDrawer {
  constructor() {
    super();

    this.trigger = document.getElementById('CountrySelectorDrawerTrigger');
    this.form = this.drawer.querySelector('form');

    if (this.trigger) {
      this.trigger.addEventListener('click', () => this.openDrawer());
    }

    const [mainBody, formBody] = this.drawer.querySelectorAll('.country-selector__body');

    this.drawer.querySelectorAll('.country-selector__toggle').forEach(toggle => {
      toggle.addEventListener('click', () => {
        if (mainBody.hidden) {
          formBody.hidden = true;
          mainBody.hidden = false;
        } else {
          formBody.hidden = false;
          mainBody.hidden = true;
        }
      });
    });
  }
}

customElements.define('country-selector', CountrySelectorDrawer);